import { Component, computed, input } from '@angular/core';
import { Category, Severity, Verdict } from '../../../core/models/common.models';

type ChipKind = 'verdict' | 'severity' | 'category';

@Component({
  selector: 'app-status-chip',
  standalone: true,
  templateUrl: './status-chip.component.html',
  styleUrl: './status-chip.component.scss',
})
export class StatusChipComponent {
  kind = input.required<ChipKind>();
  value = input.required<Verdict | Severity | Category | string>();

  readonly cssClass = computed(() => {
    const normalizedValue = `${this.value()}`.replace(/\s+/g, '-').toLowerCase();
    return `${this.kind()} ${normalizedValue}`;
  });
}
